var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.426,
    height: 19.426,
    viewBox: "0 0 19.426 19.426",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bulk_danger",
    "data-name": "vuesax/bulk/danger",
    transform: "translate(-428 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "danger",
    transform: "translate(428 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.35,11.267,11.17,1.943A3.227,3.227,0,0,0,8.45,0a3.227,3.227,0,0,0-2.72,1.943L.55,11.267a3.2,3.2,0,0,0-.2,3.23A3.186,3.186,0,0,0,3.27,15.889H13.63A3.186,3.186,0,0,0,16.552,14.5,3.2,3.2,0,0,0,16.35,11.267Z",
    transform: "translate(1.263 1.619)",
    fill: "#de1e1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M.607,5.261A.611.611,0,0,1,0,4.654V.607A.611.611,0,0,1,.607,0a.611.611,0,0,1,.607.607V4.654A.611.611,0,0,1,.607,5.261Z",
    transform: "translate(9.106 6.678)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M.809,1.621A1.216,1.216,0,0,1,.648,1.6.514.514,0,0,1,.5,1.556a.613.613,0,0,1-.146-.073l-.121-.1A.851.851,0,0,1,0,.811.851.851,0,0,1,.235.237L.356.14A.613.613,0,0,1,.5.067.514.514,0,0,1,.648.018a.693.693,0,0,1,.316,0,.488.488,0,0,1,.154.049A.613.613,0,0,1,1.263.14l.121.1a.851.851,0,0,1,.235.575.851.851,0,0,1-.235.575l-.121.1a.613.613,0,0,1-.146.073A.488.488,0,0,1,.963,1.6.992.992,0,0,1,.809,1.621Z",
    transform: "translate(8.903 12.948)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H19.426V19.426H0Z",
    fill: "none",
    opacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.494a84200eb3079577181a2b325864df.svg";
export { ForwardRef as ReactComponent };